import { SearchOutlined } from '@ant-design/icons'
import { Input } from 'antd'

interface ControlBarSearchProps {
  onChange: (value: string) => void
  /** Omit to leave the box uncontrolled -- for a debounced search, where the
   * caller holds a value that deliberately lags what has been typed. */
  value?: string
  placeholder?: string
}

/**
 * A grid control bar's search box. Passed as GraviGrid's `customSearchBar`,
 * which replaces its built-in box rather than sitting beside it -- so the
 * input lives here, and the caller owns whatever filtering it drives. Pair it
 * with `fullWidthSearchBar` to give the box the bar's spare width.
 */
export function ControlBarSearch({
  onChange,
  value,
  placeholder = 'Search here',
}: ControlBarSearchProps) {
  return (
    <Input
      prefix={<SearchOutlined />}
      placeholder={placeholder}
      allowClear
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  )
}
